// = Libs =
import { FC, useEffect, useState } from 'react';

// = Styles =
import classes from '@/components/form/form.module.scss';

// = Imports =
import { CreatePollForm } from '@/pages/poll/new-poll/new-poll.types';
import CustomInput from '@/components/custom-input/custom-input';
import { Form, Formik } from 'formik';
import {
  PERIODICITY_OPTIONS,
  VALIDATION_SCHEMA,
} from '@/pages/poll/new-poll/new-poll.constants';
import ButtonGroup from '@/common/components/ui/buttons/button-group/button-group';
import Button from '@/common/components/ui/buttons/button/button';
import {
  getSubordinates,
  OrgShort,
  useOrgData,
  useOrgList,
  useSubordinates,
} from '@/services/organization.service';
import { OptionModel } from '@/common/components/ui/select/select.types';

const PollSettings: FC<{
  orgId: number;
  initialValues: CreatePollForm;
  handleSubmit: (values: CreatePollForm) => any;
  disableFields?: string[];
}> = (props) => {
  const { orgId, initialValues, handleSubmit, disableFields = [] } = props;

  const org = useOrgData(orgId);

  const orgs = useOrgList();

  const orgToOptionModel = (org: OrgShort) => {
    return { value: org?.orgID, label: org?.name };
  };

  const authorOrgs: OptionModel[] = orgs?.author.map(orgToOptionModel);

  const [author, setAuthor] = useState<number>(orgId);
  const [executorOrgs, setExecutorOrgs] = useState<OptionModel[]>(
    useSubordinates(author)?.map(orgToOptionModel)
  );

  useEffect(() => {
    const fetchData = async () => {
      setExecutorOrgs((await getSubordinates(author)).map(orgToOptionModel));
    };
    fetchData();
  }, [author]);

  return (
    <Formik
      initialValues={{ ...initialValues }}
      validationSchema={VALIDATION_SCHEMA}
      onSubmit={handleSubmit}>
      {({ values }) => (
        <Form className={classes.form}>
          {/*<p>{JSON.stringify(values)}</p>*/}
          <h3 className={classes.form__subtitle}>Данные мониторинга</h3>
          <CustomInput
            name={'author'}
            value={orgId}
            inputType={'select'}
            text={'Автор мониторинга'}
            config={{
              options: authorOrgs,
              defaultSelect: orgId,
            }}
            formik={true}
            required
            fullWidth
            disabled={disableFields.includes('author')}
            onChange={(author) => setAuthor(Number(author))}
          />
          <CustomInput
            name={'periodicType'}
            value={''}
            inputType={'select'}
            text={'Периодичность'}
            formik={true}
            config={{
              options: PERIODICITY_OPTIONS,
            }}
            required
            fullWidth
            disabled={disableFields.includes('periodicType')}
          />
          <CustomInput
            name={'title'}
            value={values['title']}
            inputType={'text'}
            text={'Название мониторинга'}
            formik={true}
            required
            fullWidth
          />

          <CustomInput
            name={'description'}
            value={''}
            inputType={'rich-text'}
            text={'Описание'}
            formik={true}
            fullWidth
          />
          <CustomInput
            name={'startDate'}
            value={''}
            inputType={'calendar'}
            text={'Дата начала'}
            formik={true}
            required
          />
          <CustomInput
            name={'finishDate'}
            value={''}
            inputType={'calendar'}
            text={'Дата окончания'}
            formik={true}
            required
          />
          <h3 className={classes.form__subtitle}>Исполнители</h3>
          <CustomInput
            name={'isPublic'}
            value={''}
            inputType={'checkbox'}
            text={'Сделать опрос общедоступным'}
            formik={true}
          />
          <CustomInput
            name={'executors'}
            value={''}
            inputType={'multiple-select'}
            text={'Исполнители'}
            config={{ options: executorOrgs }}
            formik={true}
            required
            fullWidth
            disabled={values.isPublic}
          />
          <CustomInput
            name={'transmittalLetter'}
            inputType={'file'}
            formik
            text={'Сопроводительное письмо'}
            value={''}
            required
          />

          <ButtonGroup>
            <Button size="large" type="submit" color="primary">
              Сохранить
            </Button>

            <Button size="large" color="secondary">
              Отменить
            </Button>
          </ButtonGroup>
        </Form>
      )}
    </Formik>
  );
};

export default PollSettings;
